import React, { useEffect } from "react";
import {
  Icon,
  IconButton,
  mergeStyles,
  mergeStyleSets,
  TooltipHost,
} from "office-ui-fabric-react";
import { CenteredCell } from "../../components/styled";
import { Tooltip } from "@fluentui/react-components";
import { formatDateString } from "library/utils";

import { ExpandedColumn } from "library/types/columns";
import { StatusCell } from "./components/StatusCell";
import { ContextButton } from "./components/ContextButton";
import { LicensePlateCell } from "./components/LicensePlateCell";
import { BriefcaseRegular, PersonRegular } from "@fluentui/react-icons";

// import { ExpandedColumn } from "../../types/columns";
// import { ContextButton } from "./components/ContextButton";
// import { LicensePlateCell } from "./components/LicensePlateCell";
// import { StatusCell } from "./components/StatusCell";

// import { ContextButton } from "./components/ContextButton";
// import { LicensePlateCell } from "./components/LicensePlateCell";
// import { StatusCell } from "./components/StatusCell";

export const defaultCols: ExpandedColumn[] = [
  {
    key: "Status",
    labelKey: "greco.status",
    width: 10,
    isVisible: true,
    isFixed: true,
    filter: {
      type: "taxonomy",
      taxonomyKey: "SAGStatus",
      value: [],
      exclude: ["SAGStatus.INVOICE"],
    },
    detailsListColumn: ({ t, width }) => ({
      key: "Status",
      label: t("greco.status"),
      width,
      isSortable: true,
      render: ({ row }) => {
        if (!row) return null;
        return (
          <CenteredCell>
            <StatusCell offer={row} />
          </CenteredCell>
        );
      },
    }),
  },
  {
    key: "VehicleLicensePlate",
    labelKey: "sag.calculationForm.vehicleLicensePlate.label",
    width: 150,
    isVisible: true,
    isFixed: true,
    detailsListColumn: ({ t, width }) => ({
      key: "VehicleLicensePlate",
      label: t("sag.offers.vehicleLicensePlate.label"),
      width,
      isSortable: true,
      render: ({ row }) => {
        if (!row) return null;
        return <LicensePlateCell offer={row} />;
      },
    }),
  },
  {
    key: "options",
    labelKey: "",
    width: 40,
    isVisible: true,
    isFixed: true,
    detailsListColumn: ({ width }) => ({
      key: "options",
      label: "",
      isSortable: false,
      width,
      render: ({ row }) => {
        return (
          <CenteredCell>
            <ContextButton offer={row} />
          </CenteredCell>
        );
      },
    }),
  },
  {
    key: "SelectedInsurer",
    labelKey: "",
    width: 200,
    isVisible: true,
    isFixed: true,
    detailsListColumn: ({ width }) => ({
      key: "options",
      label: "",
      isSortable: false,
      width,
      render: ({ row }) => {
        if (!row) return null;
        const insurers = [...(row ? (row["OfferedInsurers"] as any[]) : [])];
        const insurerIcons = insurers.map((insurerName) => {
          const classes = mergeStyleSets({
            img22: {
              verticalAlign: "middle",
              maxHeight: "20px",
              maxWidth: "20px",
              marginLeft: "5px",
              marginRight: "5px",
              // boxShadow: '0 0 2px #ffee10',
              // textShadow: '0 0 2px #ffee10'
            },
            imgOpacity: {
              opacity: 0.8,
              filter: "opacity(0.8) grayscale(1)",
            },
          });

          return (
            <img
              src={`/insurers/${insurerName}.png`}
              className={`${classes.img22} ${
                row.SelectedInsurer !== insurerName || row.Status !== "3"
                  ? " " + classes.imgOpacity
                  : ""
              }`}
              alt={insurerName}
            />
          );
        });
        return <CenteredCell>{insurerIcons}</CenteredCell>;
      },
    }),
  },
  {
    key: "OfferRequestedAt",
    labelKey: "sag.offers.offerRequestedAt.label",
    width: 200,
    isVisible: true,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width }) => ({
      key: "OfferRequestedAt",
      label: t("sag.offers.offerRequestedAt.label"),
      width,
      isSortable: true,
      transform: ({ row }) =>
        row?.OfferRequestedAt ? formatDateString(row?.OfferRequestedAt) : null,
    }),
  },
  {
    key: "PolicyStartDate",
    labelKey: "sag.offers.policyStartDate.label",
    width: 200,
    isVisible: true,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width }) => ({
      key: "PolicyStartDate",
      label: t("sag.offers.policyStartDate.label"),
      width,
      isSortable: true,
      transform: ({ row }) =>
        row?.PolicyStartDate ? formatDateString(row?.PolicyStartDate) : null,
    }),
  },
  {
    key: "IsOwnerLegalPerson",
    labelKey: "sag.offers.isOwnerLegalPerson.label",
    width: 50,
    isVisible: true,
    detailsListColumn: ({ t, width }) => ({
      key: "IsOwnerLegalPerson",
      label: "", //t('sag.offers.isOwnerLegalPerson.label')
      width,
      isSortable: true,
      render: ({ row }) => {
        return (
          <CenteredCell>
            {row.IsOwnerLegalPerson ? (
              <TooltipHost
                content={t("sag.offers.isOwnerLegalPerson.tooltip.company")}
              >
                <BriefcaseRegular fontSize={24} />
              </TooltipHost>
            ) : (
              <TooltipHost
                content={t("sag.offers.isOwnerLegalPerson.tooltip.person")}
              >
                <PersonRegular fontSize={24} />
              </TooltipHost>
            )}
          </CenteredCell>
        );
      },
    }),
  },
  {
    key: "OwnerId",
    labelKey: "sag.offers.ownerId.label",
    width: 170,
    isVisible: true,
    detailsListColumn: ({ t, width }) => ({
      key: "OwnerId",
      label: t("sag.offers.ownerId.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "OwnerLastName",
    labelKey: "sag.offers.ownerLastName.label",
    width: 200,
    isVisible: true,
    detailsListColumn: ({ t, width }) => ({
      key: "OwnerLastName",
      label: t("sag.offers.ownerLastName.label"),
      width,
      isSortable: true,
      render: ({ row }) => {
        return (
          <CenteredCell>
            {row.IsOwnerLegalPerson && row.OwnerLastName}
            {!row.IsOwnerLegalPerson &&
              row.OwnerFirstName + " " + row.OwnerLastName}
          </CenteredCell>
        );
      },
    }),
  },

  {
    key: "VehicleVin",
    labelKey: "sag.offers.vehicleVin.label",
    width: 200,
    isVisible: true,
    detailsListColumn: ({ t, width }) => ({
      key: "VehicleVin",
      label: t("sag.offers.vehicleVin.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleBrand",
    labelKey: "sag.offers.vehicleBrand.label",
    width: 170,
    isVisible: true,
    detailsListColumn: ({ t, width }) => ({
      key: "VehicleBrand",
      label: t("sag.offers.vehicleBrand.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleModel",
    labelKey: "sag.offers.vehicleModel.label",
    width: 200,
    isVisible: true,
    detailsListColumn: ({ t, width }) => ({
      key: "VehicleModel",
      label: t("sag.offers.vehicleModel.label"),
      width,
      isSortable: true,
    }),
  },
  // {
  //   key: "VehicleClass",
  //   labelKey: "sag.offers.vehicleClass.label",
  //   width: 200,
  //   isVisible: false,
  //   detailsListColumn: ({ t, width, taxonomy }) => ({
  //     key: "VehicleClass",
  //     label: t("sag.offers.vehicleClass.label"),
  //     width,
  //     isSortable: true,
  //     transform: ({ row }) => {
  //       if (!row) return;
  //       return t(taxonomy.SAGVehicleClass.byId[row.VehicleClass]?.code);
  //     },
  //   }),
  // },
  // {
  //   key: "VehicleUsage",
  //   labelKey: "sag.offers.vehicleUsage.label",
  //   width: 200,
  //   isVisible: false,
  //   detailsListColumn: ({ t, width, taxonomy }) => ({
  //     key: "VehicleUsage",
  //     label: t("sag.offers.vehicleUsage.label"),
  //     width,
  //     isSortable: true,
  //     transform: ({ row }) => {
  //       if (!row) return;
  //       return t(taxonomy.SAGVehicleUsageType.byId[row.VehicleUsage]?.code);
  //     },
  //   }),
  // },
  {
    key: "StatusDescription",
    labelKey: "sag.offers.statusDescription.label",
    width: 200,
    isVisible: false,
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "StatusDescription",
      label: t("sag.offers.statusDescription.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleCubicCapacity",
    labelKey: "sag.offers.vehicleCubicCapacity.label",
    width: 100,
    isVisible: false,
    filter: {
      type: "number",
      number1: null,
      number2: null,
      operator: "gt",
      format: "integer",
      isNegativeAllowed: false,
      includeThousandSeparators: false,
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehicleCubicCapacity",
      label: t("sag.offers.vehicleCubicCapacity.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleMaximumGrossWeight",
    labelKey: "sag.offers.vehicleMaximumGrossWeight.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "number",
      number1: null,
      number2: null,
      operator: "gt",
      format: "integer",
      isNegativeAllowed: false,
      includeThousandSeparators: false,
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehicleMaximumGrossWeight",
      label: t("sag.offers.vehicleMaximumGrossWeight.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehiclePowerKw",
    labelKey: "sag.offers.vehiclePowerKw.label",
    width: 100,
    isVisible: false,
    filter: {
      type: "number",
      number1: null,
      number2: null,
      operator: "gt",
      format: "integer",
      isNegativeAllowed: false,
      includeThousandSeparators: false,
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehiclePowerKw",
      label: t("sag.offers.vehiclePowerKw.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleWeight",
    labelKey: "sag.offers.vehicleWeight.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "number",
      number1: null,
      number2: null,
      operator: "gt",
      format: "integer",
      isNegativeAllowed: false,
      includeThousandSeparators: false,
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehicleWeight",
      label: t("sag.offers.vehicleWeight.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleSeats",
    labelKey: "sag.offers.vehicleSeats.label",
    width: 100,
    isVisible: false,
    filter: {
      type: "number",
      number1: null,
      number2: null,
      operator: "gt",
      format: "integer",
      isNegativeAllowed: false,
      includeThousandSeparators: false,
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehicleSeats",
      label: t("sag.offers.vehicleSeats.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "PaymentCount",
    labelKey: "sag.offers.paymentCount.label",
    width: 100,
    isVisible: false,
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "PaymentCount",
      label: t("sag.offers.paymentCount.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "VehicleManufacturedOn",
    labelKey: "sag.offers.vehicleManufacturedOn.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehicleManufacturedOn",
      label: t("sag.offers.vehicleManufacturedOn.label"),
      width,
      isSortable: true,
      transform: ({ row }) => {
        return row?.VehicleManufacturedOn
          ? formatDateString(row?.VehicleManufacturedOn)
          : null;
      },
    }),
  },
  {
    key: "VehicleFirstRegistrationOn",
    labelKey: "sag.offers.vehicleFirstRegistrationOn.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "VehicleFirstRegistrationOn",
      label: t("sag.offers.vehicleFirstRegistrationOn.label"),
      width,
      isSortable: true,
      transform: ({ row }) => {
        return row?.VehicleFirstRegistrationOn
          ? formatDateString(row?.VehicleFirstRegistrationOn)
          : null;
      },
    }),
  },
  // {
  //   key: "PolicyPeriod",
  //   labelKey: "sag.offers.policyPeriod.label",
  //   width: 150,
  //   isVisible: false,
  //   detailsListColumn: ({ t, width, taxonomy }) => ({
  //     key: "PolicyPeriod",
  //     label: t("sag.offers.policyPeriod.label"),
  //     width,
  //     isSortable: true,
  //     transform: ({ row }) => {
  //       if (!row) return;
  //       return t(taxonomy.SAGPolicyPeriod.byId[row.PolicyPeriod]?.code);
  //     },
  //   }),
  // },
  {
    key: "OwnerAddress",
    labelKey: "sag.offers.ownerAddress.label",
    width: 300,
    isVisible: false,
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "OwnerAddress",
      label: t("sag.offers.ownerAddress.label"),
      width,
      isSortable: true,
    }),
  },
  {
    key: "OwnerBirthDate",
    labelKey: "sag.offers.ownerBirthDate.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "OwnerBirthDate",
      label: t("sag.offers.ownerBirthDate.label"),
      width,
      isSortable: true,
      transform: ({ row }) => {
        return row?.OwnerBirthDate
          ? formatDateString(row?.OwnerBirthDate)
          : null;
      },
    }),
  },
  {
    key: "OwnerDrivingLicenseDate",
    labelKey: "sag.offers.ownerDrivingLicenseDate.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "OwnerDrivingLicenseDate",
      label: t("sag.offers.ownerDrivingLicenseDate.label"),
      width,
      isSortable: true,
      transform: ({ row }) => {
        return row?.OwnerDrivingLicenseDate
          ? formatDateString(row?.OwnerDrivingLicenseDate)
          : null;
      },
    }),
  },
  {
    key: "LastModifiedAt",
    labelKey: "sag.offers.lastModifiedAt.label",
    width: 150,
    isVisible: false,
    filter: {
      type: "date",
      date1: null,
      date2: null,
      operator: "isAfter",
    },
    detailsListColumn: ({ t, width, taxonomy }) => ({
      key: "LastModifiedAt",
      label: t("sag.offers.lastModifiedAt.label"),
      width,
      isSortable: true,
      transform: ({ row }) => {
        return row?.LastModifiedAt
          ? formatDateString(row?.LastModifiedAt)
          : null;
      },
    }),
  },
];
